import { PrimitiveValue } from './primitive-value';

export class IntegerValue extends PrimitiveValue<number> {
  toString(): string {
    return this.value.toString();
  }

  /**
   * 左右を逆にして使えばよいため、 gt(), gte() は実装しない。
   */
  lt(other: IntegerValue): boolean {
    return this.value < other.value;
  }

  lte(other: IntegerValue): boolean {
    return this.value <= other.value;
  }
}
